// extracted by mini-css-extract-plugin
export default {"avatars":"avatars_avatars__wsKiw","avatar":"avatars_avatar__zUAck","avatarMore":"avatars_avatarMore__dlxRU"};